export interface ToastAction {
    label: string;
    onClick: (toastId: number) => void;
}

export interface Toast {
    id: number;
    title: string;
    message: string;
    type?: 'success' | 'danger' | 'warning' | 'info';
    duration?: number | null;
    action?: ToastAction;
}

export const useToasts = () => {
    const toasts = useState<Toast[]>('toasts', () => []);
    const removeToast = (id: number) => {
        toasts.value = toasts.value.filter(t => t.id !== id);
    };
    const addToast = (
        title: string,
        message: string,
        type: Toast['type'] = 'success',
        duration: number | null = 5000,
        action?: ToastAction
    ) => {
        const id = Date.now();
        toasts.value.push({id, title, message, type, duration, action});

        if (duration && duration > 0) {
            setTimeout(() => removeToast(id), duration);
        }
    };

    return {toasts, addToast, removeToast};
};